// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* text sizes */\n\n:root {\n\t--font-size-1: 12px;\n\t--font-size-2: 14px;\n\t--font-size-3: 18px;\n\t--font-size-4: 24px;\n\t--font-size-5: 32px;\n}\n\n.O4UaKY4FuHcWw2SioDQ3 {\n\tfont-size: var(--font-size-1);\n}\n\n.KZXhM3v44O4kHfwz2xZD {\n\tfont-size: var(--font-size-2);\n}\n\n.zYD7jD9LmBQdjnWCO1NM {\n\tfont-size: var(--font-size-3);\n}\n\n._K_AeJp32QkrG7Zxm2IX {\n\tfont-size: var(--font-size-4);\n}\n\n.a6eoiShzV7QgtDmMjvhP {\n\tfont-size: var(--font-size-5);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontSize1": "O4UaKY4FuHcWw2SioDQ3",
	"fontSize2": "KZXhM3v44O4kHfwz2xZD",
	"fontSize3": "zYD7jD9LmBQdjnWCO1NM",
	"fontSize4": "_K_AeJp32QkrG7Zxm2IX",
	"fontSize5": "a6eoiShzV7QgtDmMjvhP"
};
export default ___CSS_LOADER_EXPORT___;
